import { render, staticRenderFns } from "./TriangleTests.vue?vue&type=template&id=7f0e6c2a&"
import script from "./TriangleTests.vue?vue&type=script&lang=js&"
export * from "./TriangleTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports